import { jsx as _jsx } from "react/jsx-runtime";
import { DataGrid } from '@mui/x-data-grid';
import styles from './Table.module.scss';
export function Table(props) {
    return (_jsx(DataGrid, Object.assign({ className: styles['con-table'], disableColumnMenu: true, showCellVerticalBorder: true }, props)));
}
